<template>
    <TableFilter :scheme-type="enumDef.filterSchemeType.BuyerExchangeReceivables"
                 :filter-refs="$refs"
                 @apply-filter="applyFilter"
    >
        <!-- debtor -->
        <div class="filter_item filter_item_s">
            <div class="filter_head">{{$t("common.debtor")}}</div>
            <TextFilter :label-text="$t('common.name')"
                        column-name="debtorName"
                        ref="filter_debtorName"
            ></TextFilter>
            <TextFilter :label-text="$t('common.riskScore')"
                          column-name="debtorCreditsafeRating"
                          ref="filter_debtorCreditsafeRating"
            ></TextFilter>
            <IndustryFilter :label-text="$t('common.industry')"
                            column-name="debtorIndustryNaceCode"
                            ref="filter_debtorIndustry"
            ></IndustryFilter>
            <CountryFilter :label-text="$t('common.country')"
                           :company-type="enumDef.companyType.DebtorCompany"
                           column-name="debtorCountry"
                           ref="filter_debtorCountry">
            </CountryFilter>
            <FromToFilter v-if="ratingConfig && ratingConfig.showRating1"
                          :label-text="ratingConfig.nameRating1"
                          column-name="debtorRating1"
                          ref="filter_debtorRating1"
            ></FromToFilter>
            <FromToFilter v-if="ratingConfig && ratingConfig.showRating2"
                          :label-text="ratingConfig.nameRating2"
                          column-name="debtorRating2"
                          ref="filter_debtorRating2"
            ></FromToFilter>
            <FromToFilter v-if="ratingConfig && ratingConfig.showRating3"
                          :label-text="ratingConfig.nameRating3"
                          column-name="debtorRating3"
                          ref="filter_debtorRating3"
            ></FromToFilter>
        </div>
        <!-- seller -->
        <div class="filter_item filter_item_s">
            <div class="filter_head">{{$t("common.seller")}}</div>
            <TextFilter :label-text="$t('common.name')"
                        column-name="sellerName"
                        ref="filter_sellerName"
            ></TextFilter>
            <TextFilter :label-text="$t('common.riskScore')"
                          column-name="sellerCreditsafeRating"
                          ref="filter_sellerCreditsafeRating"
            ></TextFilter>
            <IndustryFilter :label-text="$t('common.industry')"
                            column-name="sellerIndustryNaceCode"
                            ref="filter_sellerIndustry"
            ></IndustryFilter>
            <CountryFilter :label-text="$t('common.country')"
                           column-name="sellerCountry"
                           ref="filter_sellerCountry">
            </CountryFilter>
			<TextFilter :label-text="$t('common.partner')"
						   column-name="partnerName"
						   ref="filter_partnerName"
		    ></TextFilter>
            <FromToFilter v-if="ratingConfig && ratingConfig.showRating1"
                          :label-text="ratingConfig.nameRating1"
                          column-name="sellerRating1"
                          ref="filter_sellerRating1"
            ></FromToFilter>
            <FromToFilter v-if="ratingConfig && ratingConfig.showRating2"
                          :label-text="ratingConfig.nameRating2"
                          column-name="sellerRating2"
                          ref="filter_sellerRating2"
            ></FromToFilter>
            <FromToFilter v-if="ratingConfig && ratingConfig.showRating3"
                          :label-text="ratingConfig.nameRating3"
                          column-name="sellerRating3"
                          ref="filter_sellerRating3"
            ></FromToFilter>
        </div>
        <!-- data base 12Month -->
        <div class="filter_item filter_item_xl">
            <div class="filter_head">{{$t("investor.exchange.filter.riskAnalysis.groupTitle")}}</div>
            <FromToFilter :label-text="$t('investor.exchange.table.filter.riskAnalysis.all')"
                          column-name="assessmentTotalCases"
                          field-type="I"
                          ref="filter_assessmentTotalCases"
            ></FromToFilter>
            <FromToFilter :label-text="$t('investor.exchange.table.header.riskAnalysis.latePaymentDays')"
                          column-name="assessmentMeanLpd"
                          ref="filter_assessmentMeanLpd"
            ></FromToFilter>
            <FromToFilter :label-text="$t('investor.exchange.filter.riskAnalysis.soldAmountUnpaidAndOverdue')"
                          column-name="assessmentSoldAmountUnpaidOverdue"
                          ref="filter_assessmentSoldAmountUnpaidOverdue"
            ></FromToFilter>
            <BooleanFilter :label-text="$t('investor.exchange.table.header.riskAnalysis.directPay')"
                          column-name="assessmentDirectPay"
                          ref="filter_assessmentDirectPay"
            ></BooleanFilter>
        </div>
        <!-- receivable detail -->
        <div class="filter_item filter_item_l">
            <div class="filter_head">{{$t("common.receivableDetails")}}</div>
            <EnumFilter :label-text="$t('common.type')"
                        column-name="receivableType"
                        :enum-def="enumDef.receivableType"
                        ref="filter_receivableType"
            ></EnumFilter>
            <FromToFilter :label-text="$t('common.amount')"
                          column-name="receivableAmount"
                          ref="filter_receivableAmount"
            ></FromToFilter>
            <DateFilter :label-text="$t('common.dueDate')"
                        column-name="dueDate"
                        ref="filter_dueDate"
            ></DateFilter>
            <CountryFilter :label-text="$t('common.applicableLaw')"
                           :companyType="enumDef.companyType.DebtorCompany"
                           column-name="applicableLaw"
                           ref="filter_applicableLaw"
            ></CountryFilter>
            <EnumFilter :label-text="$t('common.assignmentType')"
                        column-name="postTrade"
                        :enum-def="enumDef.postTradeType"
                        ref="filter_postTrade"
            ></EnumFilter>
			<TextFilter :label-text="$t('common.contractNumber')"
						column-name="installmentContractNumber"
						ref="filter_installmentContractNumber"
			></TextFilter>
        </div>
        <!-- sales offer -->
        <div class="filter_item filter_item_xl">
            <div class="filter_head">{{$t("investor.exchange.filter.salesOffer.groupTitle")}}</div>
            <FromToFilter :label-text="$t('investor.exchange.filter.currentRoi')"
                          column-name="instantBuyRoi"
                          ref="filter_instantBuyRoi"
            ></FromToFilter>
            <DateFilter :label-text="$t('common.endTime')"
                        column-name="endTime"
                        ref="filter_endTime"
            ></DateFilter>
        </div>
    </TableFilter>
</template>

<script>
import {enumDef} from "@/common/enumDefs";

import EnumFilter from "@/components/newFilter/EnumFilter";
import TextFilter from "@/components/newFilter/TextFilter";
import FromToFilter from "@/components/newFilter/FromToFilter";
import IndustryFilter from "@/components/newFilter/IndustryFilter.vue";
import CountryFilter from "@/components/newFilter/CountryFilter";
import DateFilter from "@/components/newFilter/DateFilter";
import TableFilter from "@/components/newFilter/TableFilter";
import BooleanFilter from "@/components/newFilter/BooleanFilter";

export default {
    props: {
        ratingConfig: Object
    },
    components: {
	    BooleanFilter,
        TableFilter,
        DateFilter,
        IndustryFilter,
        TextFilter,
        EnumFilter,
        FromToFilter,
        CountryFilter,
    },
    data() {
        return {
            enumDef: enumDef,
        };
    },
    methods: {
        applyFilter(filters) {
            this.$emit("apply-filter", filters);
        }
    },
};
</script>